import React from 'react';
import { motion } from 'framer-motion';
export function CTAStrip() {
  return <section className="bg-black text-cream py-24 lg:py-32 px-6" data-id="element-26">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-27">
        <h2 className="font-serif text-4xl lg:text-5xl font-light mb-6" data-id="element-28">
          Begin Your <span className="italic text-taupe" data-id="element-29">Transformation</span>
        </h2>

        <p className="font-sans text-cream/70 text-lg mb-10" data-id="element-30">
          Schedule your private consultation with Parkway Esthetics today.
        </p>

        <a href="#" className="bg-cream text-black px-10 py-4 text-xs uppercase tracking-widest font-sans hover:bg-taupe transition-colors mb-6" data-id="element-31">
          Book Appointment
        </a>

        <a href="tel:+17269007476" className="text-sm font-sans text-taupe hover:text-cream transition-colors" data-id="element-32">
          or call +1 726-900-7476
        </a>
      </motion.div>
    </section>;
}